import { render, staticRenderFns } from "./coreTechnologies.vue?vue&type=template&id=27faff09&scoped=true"
import script from "./coreTechnologies.vue?vue&type=script&lang=js"
export * from "./coreTechnologies.vue?vue&type=script&lang=js"
import style0 from "./coreTechnologies.vue?vue&type=style&index=0&id=27faff09&prod&lang=scss&scoped=true"
import style1 from "./coreTechnologies.vue?vue&type=style&index=1&id=27faff09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27faff09",
  null
  
)

export default component.exports